export default __webpack_public_path__ + "static/media/servicedesk.46977e30.svg";